import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { CustomCheckBox } from "hesus-ui-kit";
import { CheckboxGridRow } from "./MaterialUsage.styled";
import {
  ErrorLabel,
  ComponentContainer,
} from "../../AddEditCenterProduct.styled";

const MaterialUsage = (props) => {
  const { t, materialList, selectedMaterials, setFormData, error, formData } =
    props;

  const onMaterialClick = (e, id) => {
    if (selectedMaterials.indexOf(id) === -1 && e.currentTarget.checked)
      selectedMaterials.push(id);
    else {
      const index = selectedMaterials.indexOf(id.toString());
      if (index >= 0) {
        selectedMaterials.splice(index, 1);
      }
    }
    setFormData({
      ...formData,
      materialUsages: {
        value: selectedMaterials.length > 0 ? selectedMaterials.join() : "",
        error: "",
        required: true,
      },
    });
  };

  return (
    <>
      {materialList.length > 0 && (
        <ComponentContainer error={error !== ""}>
          <CheckboxGridRow column="1fr 1fr 1fr">
            {materialList.map((material) => (
              <div
                style={{ margin: "5px 0 5px 0" }}
                key={`${material.id}${"-"}${material.name}`}
              >
                <CustomCheckBox
                  id={"usage_" + material.id}
                  key={material.id}
                  labelText={`${material.name}`}
                  dataId={material.id}
                  onChange={(e) => {
                    onMaterialClick(e, material.id);
                  }}
                  checked={
                    selectedMaterials.indexOf(material.id.toString()) !== -1
                  }
                />
              </div>
            ))}
          </CheckboxGridRow>
        </ComponentContainer>
      )}

      {error !== "" && <ErrorLabel>{t("ERROR_MISSING_DEPARTMENT")}</ErrorLabel>}
    </>
  );
};

MaterialUsage.propTypes = {
  t: PropTypes.func.isRequired,
};
export default withTranslation()(MaterialUsage);
